import { render } from "./Title.vue?vue&type=template&id=7d119a87&scoped=true"
import script from "./Title.vue?vue&type=script&lang=ts"
export * from "./Title.vue?vue&type=script&lang=ts"

import "./Title.vue?vue&type=style&index=0&id=7d119a87&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-7d119a87"

export default script